export default __webpack_public_path__ + "styles/icons/vessel.svg";